import React from 'react'

import { ActionDropdown, Div, IconButton,Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import styles from './styles.module.css'

export type PaginatorProps = {
  totalItems: number
  changeSize: (size: number) => void
  pageSize: number
  offset: number
  goForward: () => void
  goBackward: () => void
}

const PAGE_SIZES = [5, 10, 25, 50]

const Paginator = ({
  totalItems,
  offset,
  pageSize,
  goForward,
  goBackward,
  changeSize
}: PaginatorProps) => {
  const canGoBack = offset > 0
  const canGoForwards = offset + pageSize <= totalItems
  const selectOptions = PAGE_SIZES.map(size => ({
    label: size,
    value: size,
    action: () => changeSize(size)
  }))

  return (
    <Div className={styles.container}>
      <Div className={styles.pageSizeSelectContainer}>
        <span>View</span>
        <ActionDropdown
          flowUp
          trigger={
            <Div className={styles.pageSizeSelect}>
              <span>{pageSize}</span>
              <Icon name="chevron-down" width={12} />
            </Div>
          }
          align="right"
          actions={selectOptions}
        />
        <span>rows per page</span>
      </Div>
      <Div className={styles.navigation}>
        {totalItems > pageSize && (
          <IconButton onClick={goBackward} disabled={!canGoBack} icon="arrow-1-left" size="small" />
        )}
        <Span>{`${offset + 1} - ${Math.min(offset + pageSize, totalItems).toLocaleString()} of ${
          isNaN(totalItems) ? 1 : totalItems.toLocaleString()
        }`}</Span>
        {totalItems > pageSize && (
          <IconButton
            disabled={!canGoForwards}
            onClick={goForward}
            icon="arrow-1-right"
            size="small"
          />
        )}
      </Div>
    </Div>
  )
}

export default Paginator
